export const REGEXP_NUMBERS_ONLY = new RegExp(/^\d+$/);
export const REGEX_EMAIL_CHECKER = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
export const REGEX_PHONE_NUMBER_WITH_COUNTRY_CODE = new RegExp(/^\+\d{13,15}$/)
export const REGEX_WEBSITE_CHECKER = /^(https?:\/\/)?(www\.[a-zA-Z0-9-]+\.){1,}([a-zA-Z]{2,})(\/[a-zA-Z0-9-._?%&=]*)?$/;


